module.exports = __webpack_public_path__ + "static/media/WBD-FINAL_page-0004.5a7a0f1b.jpg";